// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/opt/build/repo/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-development-js": () => import("/opt/build/repo/src/pages/development.js" /* webpackChunkName: "component---src-pages-development-js" */),
  "component---src-pages-index-js": () => import("/opt/build/repo/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-management-js": () => import("/opt/build/repo/src/pages/management.js" /* webpackChunkName: "component---src-pages-management-js" */),
  "component---src-pages-marketing-js": () => import("/opt/build/repo/src/pages/marketing.js" /* webpackChunkName: "component---src-pages-marketing-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/opt/build/repo/.cache/data.json")

